import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const PressList = lazy(() => import('@components/Group/Portfolio/PressList'));

const Press = () => {
  return (
    <ApiErrorBoundary>
      <Suspense>
        <PressList />
      </Suspense>
    </ApiErrorBoundary>
  );
};

export default Press;
